import { useEffect, useRef, useState } from 'react';
import { Palette, Check } from '@phosphor-icons/react';
import { THEMES, getTheme, applyTheme } from '@/lib/theme';

export default function ThemePicker() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState(getTheme());
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const choose = (id) => { applyTheme(id); setCur(id); setOpen(false); };

  return (
    <div className="relative" ref={ref} data-testid="theme-picker">
      <button onClick={() => setOpen(o => !o)} title="Theme" data-testid="theme-picker-btn"
        className="inline-flex items-center border border-zinc-800 px-2 py-1.5 text-zinc-400 hover:border-emerald-500 hover:text-emerald-400">
        <Palette weight="bold" className="h-4 w-4" />
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-2 w-60 border border-zinc-800 bg-zinc-950 p-1.5 shadow-2xl" data-testid="theme-menu">
          <div className="label-mini px-2 py-1.5 text-zinc-500">choose your vibe</div>
          {THEMES.map(t => (
            <button key={t.id} onClick={() => choose(t.id)} data-testid={`theme-${t.id}`}
              className={`flex w-full items-center gap-3 border px-2 py-2 text-left ${cur === t.id ? 'border-emerald-500/60 bg-emerald-500/5' : 'border-transparent hover:border-zinc-700'}`}>
              <span className="flex shrink-0 overflow-hidden border border-zinc-700">
                <span className="h-7 w-4" style={{ background: t.swatch[0] }} />
                <span className="h-7 w-4" style={{ background: t.swatch[1] }} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-xs font-bold text-zinc-100">{t.label}</span>
                <span className="block text-[10px] text-zinc-500">{t.vibe}</span>
              </span>
              {cur === t.id && <Check weight="bold" className="h-4 w-4 text-emerald-400" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
